// extracted by mini-css-extract-plugin
module.exports = {"image":"Img-module--image--26HGB","placeholderHidden":"Img-module--placeholder-hidden--3-bZ2"};